import { IAuthenticationClientRedirecter } from './IAuthenticationClientRedirecter';

/**
 * What is exposed by api-client is effectively abstract.
 *
 * In our tests, we have an implementation that makes https requests to look at location header / responses
 * and allows us to make assertions.
 *
 * In the app, we have a version that does a real redirect, changing the location of the page.
 */
export class AuthenticationClientRedirecter implements IAuthenticationClientRedirecter {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    redirect = (url: string): Promise<boolean> => {
        throw new Error('Not implemented. AuthenticationClientRedirecter must be overridden either for the browser, or for tests');
    }
}
